import { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getSurveySection, cleanCities, cleanStatesAndCities } from "app/features/surveySlice";
import { questionIds } from "../../constants/initialValues";
import Typography from "@mui/material/Typography";
import { getStates, getCities } from "app/features/surveySlice";
import { FormControlModel } from "types";
import { ElementType } from "lib/enums/enums";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step6: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { states, cities } = useAppSelector((state: any) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};
  const countries = questions[0]?.subQuestions ?? [];

  const stateTriggerId: string = questionIds.step6.placeCountry || "";
  const cityTriggerId: string = questionIds.step6.placeState || "";
  const countryKey = formik.values.placeCountry?.value;
  const stateKey = formik.values.placeState?.value;
  const cityKey = formik.values.placeCity?.value;

  const onCleanStatesAndCities = () => {
    formik.setFieldValue("placeState", {});
    formik.setFieldTouched("placeState", true, false);
    formik.setFieldValue("placeCity", {});
    formik.setFieldTouched("placeCity", true, false);
  };

  const onCleanCities = () => {
    formik.setFieldValue("placeCity", "");
  };

  const onSelectCountry = (searchId: string) => {
    dispatch(getStates({ triggerId: stateTriggerId, searchId }));
    dispatch(cleanStatesAndCities());
    onCleanStatesAndCities();
  };

  const onSelectState = (searchId: string) => {
    dispatch(getCities({ triggerId: cityTriggerId, searchId }));
    dispatch(cleanCities());
    onCleanCities();
  };

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
    dispatch(cleanStatesAndCities());
  }, []);

  useEffect(() => {
    if (stateKey) {
      dispatch(getStates({ triggerId: stateTriggerId, searchId: countryKey }));
      dispatch(getCities({ triggerId: cityTriggerId, searchId: stateKey }));
    }
  }, [stateKey, cityKey]);

  const dataModel: FormControlModel[] = [
    {
      key: 0,
      formik,
      visible: true,
      name: "placeCountry",
      questionData: countries[0],
      elementType: ElementType.Select,
      onChangeCallback: onSelectCountry,
      label: "Lugar actual de residencia",
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "placeState",
      label: "Departamento",
      elementType: ElementType.Select,
      onChangeCallback: onSelectState,
      questionData: { source: states, id: questionIds.step6.placeState },
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "placeCity",
      label: "Municipio",
      elementType: ElementType.Select,
      questionData: { source: cities, id: questionIds.step6.placeCity },
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "neighborhood",
      maxLength: 60,
      label: "Vereda/ barrio",
      questionData: questions[1],
      elementType: ElementType.Textfield,
    },
    {
      key: 4,
      formik,
      visible: true,
      maxLength: 100,
      name: "address",
      label: "Dirección",
      questionData: questions[2],
      elementType: ElementType.Textfield,
    },
    {
      key: 5,
      formik,
      visible: true,
      name: "dwellTime",
      questionData: questions[3],
      elementType: ElementType.Select,
      label: "¿Desde que año vive en el municipio?",
    },
    {
      key: 6,
      formik,
      visible: true,
      name: "houseLocation",
      questionData: questions[4],
      elementType: ElementType.Radio,
      label: "Su vivienda esta ubicada en zona",
    },
    {
      key: 7,
      formik,
      visible: true,
      name: "category",
      label: "Estrato",
      questionData: questions[5],
      elementType: ElementType.Select,
    },
    {
      key: 8,
      formik,
      visible: true,
      name: "houseType",
      label: "Tipo de vivienda",
      questionData: questions[6],
      elementType: ElementType.Select,
    },
    {
      key: 9,
      formik,
      visible: true,
      name: "houseTenure",
      questionData: questions[7],
      elementType: ElementType.Select,
      label: "Tipo de tenencia de la vivienda",
    },
  ];
  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos sobre su entorno: Información general
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step6;
